module.exports = __webpack_public_path__ + "img/asset.29fc7e02.png";